import React from 'react';
import { Pressable } from 'react-native';

import { Stack } from '@/components/layout';
import { SvgIcon, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

const strings = STRINGS.guardianPlayer.playerDetail.lessons;

type LessonsEmptyStateProps = {
  onPressBookClass: () => void;
};

export default function LessonsEmptyState({ onPressBookClass }: LessonsEmptyStateProps) {
  const styles = useStyles();
  const { scale } = useScaling();

  return (
    <Stack
      align="center"
      gap={scale(10)}
      style={styles.card}
      paddingX={scale(12)}
      paddingY={scale(10)}>
      <SvgIcon name="IcLessonsEmpty" size={scale(48)} />
      <Stack align="center" gap={scale(2)}>
        <Text variant="Font Guardian App/Subtitle/Subtitle 14 Bold" style={styles.title}>
          {strings.emptyTitle}
        </Text>
        <Text variant="Font Guardian App/Subtitle/Subtitle 12 Regular" style={styles.subtitle}>
          {strings.emptySubtitle}
        </Text>
      </Stack>
      <Pressable
        accessibilityRole="button"
        onPress={onPressBookClass}
        style={({ pressed }) => [styles.bookButton, pressed ? styles.pressed : null]}>
        <SvgIcon name="IcPlusBold" size={scale(20)} color={guardianColors['Main/Main']} />
        <Text
          variant="Font Guardian App/Subtitle/Subtitle 12 Semibold"
          style={styles.bookButtonText}>
          {strings.bookClass}
        </Text>
      </Pressable>
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  card: {
    borderRadius: scale(12),
  },
  pressed: {
    opacity: 0.72,
  },
  title: {
    color: guardianColors['6'],
    textAlign: 'center',
  },
  subtitle: {
    color: guardianColors['6'],
    textAlign: 'center',
  },
  bookButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: scale(8),
    height: scale(40),
    paddingHorizontal: scale(24),
    borderRadius: scale(12),
    borderWidth: 0.5,
    borderColor: guardianColors['Main/Main'],
    backgroundColor: colors['0'],
  },
  bookButtonText: {
    color: guardianColors['Main/Main'],
  },
}));
